var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion",class:{'accordion-card': _vm.card, 'accordion-modal': _vm.modal, 'theme-dark': _vm.dark}},[(_vm.$slots.header)?_c('div',{staticClass:"accordion-header"},[_vm._t("header")],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }